import { useEffect } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import "./responsive.css";
import Login from "./Components/Auth/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { url } from "./Config/Config";
import Layout from "./Components/Layout/Layout";
import Organizations from "./Components/Organizations/Organizations";
import Contests from "./Components/Contests/Contest";
import SupportRequest from "./Components/HelpnSupport/SupportRequest";
import NewsLetters from "./Components/HelpnSupport/NewsLetter";
import MeetingSlot from "./Components/HelpnSupport/MeetingSlot";
import SaleInquiry from "./Components/SaleInquiry/Sale_inquiries";
import Users from "./Components/Users/Users";
import UserDetail from "./Components/Users/UserDetail";
import Plans from "./Components/Payments/Plans/Plans";
import Promo from "./Components/Payments/Promo/Promo";
import ServiceCharges from "./Components/Payments/ServiceCharge/ServiceCharge";
import DLQMessages from "./Components/Payments/DLQ/DLQMessage";
import Jobs from "./Components/Careers/Jobs/Jobs";
import JobDetail from "./Components/Careers/Jobs/JobDetail/JobDetail";
import Skills from "./Components/Skills/Skills";
import PromoUsage from "./Components/Payments/Promo/PromoUsage/PromoUsage";
import Coupon from "./Components/Payments/Coupon/Coupon";
import CouponUsage from "./Components/Payments/Coupon/CouponUsage/CouponUsage";
import BadgesAndCertificates from "./Components/BadgesAndCertificates/BadgesAndCertificates";
import QuestionsVerify from "./Components/QuestionsVerify/QuestionsVerify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OrganizationDetail from "./Components/Organizations/OrganizationDetail";
import CmsPageListPage from "./Components/Cms/Pages/CmsPageListPage";
import CmsCreatePagePage from "./Components/Cms/Create/CmsCreatePagePage";
import CmsPageEditorPage from "./Components/Cms/Editor/CmsPageEditorPage";

import FeatureCatalog from "./Components/Pricing/FeatureCatalog/FeatureCatalog";
import CalculatorPresets from "./Components/Pricing/CalculatorPresets/CalculatorPresets";
import TopupPresets from "./Components/Pricing/TopupPresets/TopupPresets";
import BonusRules from "./Components/Pricing/BonusRules/BonusRules";
import CurrencyCreditRates from "./Components/Pricing/CurrencyCreditRates/CurrencyCreditRates";
import ChargeSync from "./Components/Pricing/ChargeSync/ChargeSync";
import GrantCreditsModal from "./Components/Payments/ManualCreditGrant/GrantCreditsModal";
import { FetchLoginDetail } from "./Redux/Actions/AuthAction";

function App() {
  const dispatch = useDispatch<any>();

  useEffect(() => {
    dispatch(FetchLoginDetail());
  }, [dispatch]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path={url + "/"} element={<Organizations />} />
            <Route path={url + "/organizations"} element={<Organizations />} />
            <Route
              path={url + "/organizations/:orgId"}
              element={<OrganizationDetail />}
            />
            <Route
              path={url + "/verify-questions"}
              element={<QuestionsVerify />}
            />
            {/* /brew-users */}
            <Route path={url + "/brew-users"} element={<Users />} />
            <Route path={url + "/brew-users/:userId"} element={<UserDetail />} />
            <Route path={url + "/contests"} element={<Contests />} />
            <Route
              path={url + "/support_requests/queries"}
              element={<SupportRequest />}
            />
            <Route
              path={url + "/support_requests/newsletter"}
              element={<NewsLetters />}
            />
            <Route
              path={url + "/support_requests/meetings"}
              element={<MeetingSlot />}
            />
            <Route path={url + "/sale_inquiries"} element={<SaleInquiry />} />
            <Route
              path={url + "/rewards"}
              element={<BadgesAndCertificates />}
            />
            {/* Payments */}
            <Route path={url + "/payments/plans"} element={<Plans />} />
            <Route path={url + "/payments/promo"} element={<Promo />} />
            <Route
              path={url + "/promo/usage/:promo_id"}
              element={<PromoUsage />}
            />
            <Route path={url + "/payments/coupons"} element={<Coupon />} />
            <Route
              path={url + "/coupon/usage/:coupon_id"}
              element={<CouponUsage />}
            />
            <Route
              path={url + "/payments/service-charge"}
              element={<ServiceCharges />}
            />
            <Route
              path={url + "/payments/dlq-messages"}
              element={<DLQMessages />}
            />
            <Route
              path={url + "/payments/grant-credits"}
              element={<GrantCreditsModal />}
            />
            {/* Pricing (SBW-2273) */}
            <Route
              path={url + "/pricing/feature-catalog"}
              element={<FeatureCatalog />}
            />
            <Route
              path={url + "/pricing/calculator-presets"}
              element={<CalculatorPresets />}
            />
            <Route
              path={url + "/pricing/topup-presets"}
              element={<TopupPresets />}
            />
            <Route
              path={url + "/pricing/bonus-rules"}
              element={<BonusRules />}
            />
            <Route
              path={url + "/pricing/currency-credit-rates"}
              element={<CurrencyCreditRates />}
            />
            <Route
              path={url + "/pricing/charge-sync"}
              element={<ChargeSync />}
            />
            {/* Careers */}
            <Route path={url + "/careers/jobs"} element={<Jobs />} />
            <Route path={url + "/jobs/:jobId"} element={<JobDetail />} />
            <Route path={url + "/skills"} element={<Skills />} />
            <Route path={url + "/cms/pages"} element={<CmsPageListPage />} />
            <Route path={url + "/cms/pages/new"} element={<CmsCreatePagePage />} />
            <Route
              path={url + "/cms/pages/:slug/edit"}
              element={<CmsPageEditorPage />}
            />
          </Route>
          <Route path={url + "/login"} element={<Login />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
